// extracted by mini-css-extract-plugin
export default {"title":"ContactPerson_title__ZABKR","content":"ContactPerson_content__NifBJ"};